import React, { useRef, useState, useEffect } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { toast } from "sonner";
import { FaEye } from "react-icons/fa";
// import UserDetails from "./userDetails";
import { MdBlock } from "react-icons/md";
import BlockUserModal from "./blockUserModal";
import { AiOutlineRedo } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../Components/spinner";
import BSPagination from "../../Components/pagination";
import { handleErrors } from "../../services/dataManager";
import {
  fetchUsersList,
  searchUsersbyQuery,
  toggleUserStatus,
  unBlockUserById,
} from "../../services/axios/apiManager";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import DataTable from "datatables.net";
import DT from "datatables.net-bs5";

DataTable.use(DT);

const UsersList = ({ users, setUsers, pagination, setPagination, granted }) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [filtering, setFiltering] = useState(false);
  const [filters, setFilters] = useState(4);
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [openBlockModal, setOpenBlockModal] = useState(false);

  const tableRef = useRef(null);

  const columns = [
    { data: "id", title: "ID" },
    { data: "first_name", title: "First Name" },
    { data: "last_name", title: "Last Name" },
    { data: "user_name", title: "User Name" },
    { data: "email", title: "Email" },
  ];

  // // // search User by name, email, and user name
  const searchUsers = async (e) => {
    setFiltering(true);
    setFilters(4);
    const string = e.target.value;
    setQuery(string);
    if (string.length > 0) {
      const res = await searchUsersbyQuery(
        string,
        pagination.currentPage,
        pagination.pageSize
      );
      if (res?.data?.success && res?.data?.data) {
        setUsers(res.data.data);
        if (res?.data?.pagination) {
          setPagination(res.data.pagination);
        }
      } else {
        handleErrors(res, navigate);
      }
    } else {
      fetchUserList(pagination);
    }
    setFiltering(false);
  };

  const fetchUserList = async (temp, str = filters) => {
    setFiltering(true);
    const res = await fetchUsersList(temp.currentPage, temp.pageSize, str);
    if (res?.data?.success && res?.data?.data) {
      setUsers(res.data.data);
      if (res?.data?.pagination) {
        setPagination(res.data.pagination);
      }
    } else {
      await handleErrors(res, navigate);
    }
    setFiltering(false);
  };
  // // // Fetch Filtered Users
  // // // status = 0->Inactive,1->active,2->Blocked,3->deleted,4->Active/Inactive
  const fetchFilteredUsers = async (e) => {
    setFilters(e.target.value);
    const string = `status=${e.target.value}`;
    await fetchUserList(pagination, string);
  };
  // // // Reset All filters and Fetch Data again
  const resetFilters = async () => {
    setFilters(4);
    setQuery("");
    await fetchUserList(pagination);
  };
  // // // Change the pages and fetch data
  const handlePageChange = async (page) => {
    const temp = { ...pagination };
    setPagination((prev) => ({ ...prev, currentPage: page }));
    temp.currentPage = page;
    fetchUserList(temp);
  };

  const handleCloseOptionsModal = () => {
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // // Change status Logic
  const handleStatusChange = async (usr) => {
    if (!granted?.some((g) => g.type === "toggle-status")) {
      toast.error(
        "You dont have neccessary permissions to do this operation!",
        {
          duration: 2000,
        }
      );
      return;
    }
    setModalOptions({
      header: "Change Status",
      body: `Are you sure you want to change the status of user "${usr.user_name}"?`,
      okay: "Change",
      method: changeStatus,
      data: { id: usr.id, status: usr.status === 1 ? 0 : 1 },
    });
    setShowOptionsModal(true);
  };

  const changeStatus = async (data) => {
    const res = await toggleUserStatus(data);
    if (res?.data?.success === true) {
      await fetchUserList(pagination);
    } else {
      handleErrors(res, navigate);
    }
    setModalOptions({});
    setShowOptionsModal(false);
  };

  // // // Unblock User logic
  const handleUnblockUser = async (usr) => {
    setModalOptions({
      header: "Unblock User",
      body: `Are you sure you want to Unblock the user "${usr.user_name}"?`,
      okay: "Unblock",
      method: unBlockAUser,
      data: { id: usr.id },
    });
    setShowOptionsModal(true);
  };

  const unBlockAUser = async (data) => {
    const res = await unBlockUserById(data.id);
    if (res?.data?.success) {
      await fetchUserList(pagination);
      toast.success("User has been unblocked", { duration: 2000 });
    } else {
      toast.error("Something went wrong, please try again later!", {
        duration: 2000,
      });
      handleErrors(res, navigate);
    }
    setModalOptions({});
    setShowOptionsModal(false);
  };

  const handleOpenBlockModal = (id) => {
    if (id) {
      setSelectedUserId(id);
      setOpenBlockModal(true);
    }
  };

  // const handleNavigateUserProfile = (id) => {
  //   navigate(`/UserProfile/${id}`);
  // };

  useEffect(() => {
    const tableData = users.map((user) => {
      const row = columns.map((col) => user[col.data]);

      // Status button
      row.push(`
      <button class="btn btn-sm status-btn ${user.status === 1 ? "text-success" : "text-danger"}" data-id="${user.id}" title="change status">
        ${user.status === 1 ? "Active" : "Inactive"}
      </button>
    `);

      // Actions
      let actions = `
      <button class="btn btn-outline-primary btn-sm view-btn me-1" data-id="${user.id}" title="View User">
        <i class="fas fa-eye"></i>
      </button>
    `;
      if (user?.blocked?.length && granted?.some((g) => g.type === "un-block")) {
        actions += `
              <button class="btn btn-outline-warning btn-sm unblock-btn me-1" data-id="${user.id}" title="Unblock User">
                <i class="fa-solid fa-rotate-right"></i>
              </button>
            `;
      }
      if (!user?.blocked?.length && granted?.some((g) => g.type === "block")) {
        actions += `
          <button class="btn btn-outline-danger btn-sm block-btn" data-id="${user.id}" title="Block User">
            <i class="fas fa-ban"></i>
          </button>
        `;
      }

      row.push(actions);
      return row;
    });

    const config = {
      data: tableData,
      columns: [
        { title: "ID", className: "text-start" },
        ...columns.slice(1).map((col) => ({ title: col.title })),
        { title: "Status", orderable: false },
        { title: "Actions", orderable: false },
      ],

      destroy: true,
      responsive: true,
      pageLength: pagination.pageSize || 10,
      paging: false,
      searching: false,
    };

    const $table = $(tableRef.current);

    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      $table.DataTable().clear().rows.add(tableData).draw();
    } else {
      $table.DataTable(config);
    }

    // Event: View user (redirect)
    $table.off("click", ".view-btn").on("click", ".view-btn", function () {
      const id = $(this).data("id");
      navigate(`/UserProfile/${id}`);
    });

    // Event: Change status
    $table.off("click", ".status-btn").on("click", ".status-btn", function () {
      const id = $(this).data("id");
      const usr = users.find((u) => u.id === id);
      handleStatusChange(usr);
    });

    // Event: Unblock user
    $table
      .off("click", ".unblock-btn")
      .on("click", ".unblock-btn", function () {
        const id = $(this).data("id");
        const usr = users.find((u) => u.id === id);
        handleUnblockUser(usr);
      });

    // Event: Block user
    $table.off("click", ".block-btn").on("click", ".block-btn", function () {
      const id = $(this).data("id");
      handleOpenBlockModal(id);
    });

    return () => {
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $table.DataTable().destroy();
      }
    };
  }, [users, granted]);

  return (
    <div className="container py-4 text-light bg-dark rounded mb-4">
      <div className="row align-items-center mb-4">
        <div className="col-md-3">
          <Form.Control
            type="text"
            placeholder="Search Users..."
            value={query}
            onChange={(e) => {
              searchUsers(e);
            }}
            className="bg-dark text-light border-light"
          />
        </div>
        <div className="col-md-3">
          <Form.Select
            name="status"
            value={filters}
            onChange={(e) => {
              fetchFilteredUsers(e);
            }}
            className="bg-dark border-light text-light"
          >
            <option value="4">Active & Inactive</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
            <option className="text-warning" value="2">
              Blocked
            </option>
          </Form.Select>
        </div>
        <div className="col-md-1">
          {filtering ? (
            <LoadingSpinner size={"md"} />
          ) : (
            <div className="row pr-2">
              <Button
                title="Reset Filters And Refresh Records"
                className="btn btn-success"
                onClick={() => {
                  resetFilters();
                }}
              >
                Reset
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className="table-responsive">
        <div className="table-responsive">
          <table
            ref={tableRef}
            className="table table-striped table-dark w-100"
            style={{ whiteSpace: "nowrap" }}
          />
        </div>
      </div>
      <div className="constainer-fluid">
        <div className="d-flex justify-content-end">
          <div className="mx-4 py-2">
            <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
          </div>
          <BSPagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
            siblingCount={2}
            showFirstLast={true}
          />
        </div>
      </div>
      {/* Block User Modal */}
      <BlockUserModal
        openBlockModal={openBlockModal}
        setOpenBlockModal={setOpenBlockModal}
        userID={selectedUserId}
        setUserID={setSelectedUserId}
        fetchUserList={fetchUserList}
        pagination={pagination}
        navigate={navigate}
      />
      {/* Details Modal */}
      {/* <UserDetails
        openDetailsModal={openDetailsModal}
        setOpenDetailsModal={setOpenDetailsModal}
        userID={selectedUserId}
        setUserID={setSelectedUserId}
      /> */}
      {/* Options Modal */}
      <Modal
        show={showOptionsModal}
        onHide={handleCloseOptionsModal}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark text-light border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark text-light">
          {modalOptions.body}
        </Modal.Body>
        <Modal.Footer className="bg-dark text-light border-0">
          <Button variant="secondary" onClick={handleCloseOptionsModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              modalOptions.method(modalOptions.data);
            }}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default UsersList;
